module.exports = __webpack_public_path__ + "img/subscription3.dd9e2984.png";